import { CompoundLocation } from '../../compoundManagement.types';
import { FunctionComponent } from 'react';
import { DepartureCompletedForm } from '../../shared/sidebar/DepartureCompletedForm';

export type UnannouncedDepartureDetailsProps = {
    compoundVehicleId: string;
    compoundLocation: CompoundLocation;
    disabled?: boolean | undefined;
};

export const UnannouncedDepartureDetails: FunctionComponent<UnannouncedDepartureDetailsProps> = ({
    compoundVehicleId,
    compoundLocation,
    disabled = false,
}) => (
    <>
        <DepartureCompletedForm
            key={compoundVehicleId}
            timeZone={compoundLocation.timeZone}
            compoundVehicleId={compoundVehicleId}
            meansOfTransportTypeInputDisabled={false}
            disabled={disabled}
            departureCompletedAt={undefined}
            transportInformation={undefined}
        />
    </>
);
